import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { InvestigationFormState } from '../../states/investigation-form.state';
import { GetInvestigationFormByInvestigationTypeQuery } from './get-investigation-form-by-investigation-type.query';
import { GetInvestigationFormByInvestigationTypeResult } from './get-investigation-form-by-investigation-type.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationFormByInvestigationTypeUseCase {
  private readonly _repository = inject(InvestigationFormRepository);
  private readonly _state = inject(InvestigationFormState);

  public execute(query: GetInvestigationFormByInvestigationTypeQuery): Observable<GetInvestigationFormByInvestigationTypeResult> {
    this._state.setLoadingInvestigationForms(true);
    this._state.clearErrorInvestigationForms();

    return this._repository.getInvestigationFormByInvestigationTypeId(query.investigationTypeId).pipe(
      catchError((error) => {
        const errorMessage = error?.error?.message || error?.message ||
          `Failed to load investigation form for investigation type ${query.investigationTypeId}`;
        this._state.setErrorInvestigationForms(errorMessage);
        throw error;
      }),
      finalize(() => this._state.setLoadingInvestigationForms(false))
    );
  }
}
